module.exports = __webpack_public_path__ + "img/Icon-09.be3f73a9.png";